import React from 'react';
import PropTypes from 'prop-types';

import helpers from 'app/tyler/helpers/rgb';

class RgbColor extends React.PureComponent {

  get hex() {
    const {r,g,b} = this.props;
    return [r,g,b].map(c => helpers.decToHex(c)).join('');
  }

  get hexStr() {
    return `#${this.hex}`;
  }

  get rgb() {
    const {r,g,b} = this.props;
    return `${r}, ${g}, ${b}`;
  }

  get rgbStr() {
    return `rgb(${this.rgb})`;
  }

  render() {
    return (
      <div className="rgb-color">
        <div className="rgb-color-swatch" style={{backgroundColor: this.hexStr}} />
        <div className="rgb-color-stat">{this.rgbStr}</div>
        <div className="rgb-color-stat">{this.hexStr}</div>
      </div>
    );
  }
}

RgbColor.propTypes = {
  r: PropTypes.number.isRequired,
  g: PropTypes.number.isRequired,
  b: PropTypes.number.isRequired,
};

export default RgbColor;
